import { render, staticRenderFns } from "./MhbuReportsComponent.vue?vue&type=template&id=6e2655b6"
import script from "./MhbuReportsComponent.vue?vue&type=script&lang=js"
export * from "./MhbuReportsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports